import { MapfreIputWithValidationComponent } from '../../section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreButtonComponent } from '../../individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input , NO_ERRORS_SCHEMA } from '@angular/core';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreButtonComponent, MapfreIputWithValidationComponent],
  selector: 'app-form-internal',
  templateUrl: './mapfre-form.component.html',
})
export class MapfreFormComponent {
  @Input() form:            any;
  @Input() inputs:          any;

}
